(function () {
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function getCards(track) {
    return Array.prototype.filter.call(track.children, function (child) {
      return child.classList.contains('mx-product-card') || child.classList.contains('mx-quote');
    });
  }

  function pageCount(track, cards) {
    if (!cards.length || !track.clientWidth) return 1;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var cardWidth = cards[0].getBoundingClientRect().width;
    var visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));
    return Math.ceil(cards.length / visibleCards);
  }

  function setActiveDot(track, dots) {
    var buttons = dots.querySelectorAll('.mx-swipe-dot');
    if (!buttons.length) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var activeIndex = maxScroll ? Math.round((track.scrollLeft / maxScroll) * (buttons.length - 1)) : 0;

    buttons.forEach(function (button, index) {
      var isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function renderDots(dots) {
    var track = dots.previousElementSibling;
    if (!track || !mobileQuery.matches) {
      dots.replaceChildren();
      return;
    }

    var cards = getCards(track);
    var pages = pageCount(track, cards);
    dots.replaceChildren();

    if (pages < 2) return;

    for (var index = 0; index < pages; index += 1) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mx-swipe-dot';
      button.setAttribute('aria-label', 'Go to page ' + (index + 1));
      button.dataset.page = String(index);
      dots.appendChild(button);
    }

    setActiveDot(track, dots);
  }

  function connectDots(dots) {
    var track = dots.previousElementSibling;
    if (!track) return;

    renderDots(dots);

    if (dots.dataset.mxSwipeReady === 'true') return;
    dots.dataset.mxSwipeReady = 'true';

    var frame = 0;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        setActiveDot(track, dots);
      });
    }, { passive: true });

    dots.addEventListener('click', function (event) {
      var button = event.target.closest('.mx-swipe-dot');
      if (!button) return;

      var buttons = dots.querySelectorAll('.mx-swipe-dot');
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var page = Number(button.dataset.page);
      var left = buttons.length > 1 ? (maxScroll / (buttons.length - 1)) * page : 0;
      track.scrollTo({ left: left, behavior: 'smooth' });
    });
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-mx-swipe-dots]').forEach(connectDots);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      document.querySelectorAll('[data-mx-swipe-dots]').forEach(renderDots);
    });
  }, { passive: true });
})();
